'use client'

import { RebuildNotice } from '../RebuildNotice'

export default function ActivityLogSection({ companyId: _companyId }: { companyId: string }) {
  return (
    <RebuildNotice
      title="Activity log"
      hint="VehicleActivityLog from gps-backend (9 event types)."
    />
  )
}
